import React, {Component} from 'react';
import {Grid , Cell} from 'react-mdl';

class Landing extends Component{
    render(){
        return(
        <div style ={{width:'100%', margin:'auto'}}>
            <Grid className = 'landing-grid'>
            <Cell col = {12}>
            <img
              src = "https://cdn4.iconfinder.com/data/icons/men-avatars-icons-set-1/256/16-512.png"
              alt = "avatar"
              className = "avatar-img"
            />
            <div className="banner-text">
              <h1> Software Developer </h1>
              <hr/>
              <p>
              C | C++ | Python | JAVA | HTML | CSS | JS | SQL | mySQL | React | Node | React-Native | Android | {"{ML}"} | D3
              </p>

              <div className = "social-links">

              {/* facebook */}
                <a href = "http://facebook.com/mrityunjoy.nath" rel="noopener noreferrer" target="_blank">
                  <i className = "fa fa-facebook-square" aria-hidden = "true"/>
                </a>

              {/* linkedin*/}
                <a href = "https://www.linkedin.com/in/mrityunjoy-nath/" rel="noopener noreferrer" target="_blank">
                  <i className = "fa fa-linkedin-square" aria-hidden = "true"/>
                </a>

              {/* github */}
                <a href = "https://github.com/coderperfect" rel="noopener noreferrer" target="_blank">
                  <i className = "fa fa-github-square" aria-hidden = "true"/>
                </a>

              {/* twitter */}
                <a href = "https://twitter.com/mrityunjoy_nath" rel="noopener noreferrer" target="_blank">
                  <i className = "fa fa-twitter-square" aria-hidden = "true"/>
                </a>

              </div>
            </div>
            </Cell>
            </Grid>
            </div>
        );
    }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/Components/landingpage.js